import { useAtom, useAtomValue } from 'jotai'
import { useEffect, useRef, useState } from 'react'

import {
	WELCOME_IMAGE_OVERLAY_ID,
	welcomeImageAtom,
	welcomeImageFileAtom,
} from '../contentFormSections'
import { openOverlayIdAtom } from '../generatorState'
import { QrScreenOverlay } from './QrScreenOverlay'

export const WelcomeImageOverlay = ({
	previewMode,
	demoMode,
}: {
	previewMode: boolean
	demoMode: boolean
}) => {
	const image = useAtomValue(welcomeImageAtom)
	const imageFile = useAtomValue(welcomeImageFileAtom)
	const [openOverlayId, setOpenOverlayId] = useAtom(openOverlayIdAtom)

	const [localPreviewSrc, setLocalPreviewSrc] = useState<string | null>(null)

	useEffect(() => {
		if (!imageFile) {
			setLocalPreviewSrc(null)
			return
		}
		const url = URL.createObjectURL(imageFile)
		setLocalPreviewSrc(url)
		return () => URL.revokeObjectURL(url)
	}, [imageFile])

	const cdnImageSrc = image?.publicId
		? `${image.bucketRootUrl}/${image.publicId}`
		: null
	const imageSrc = demoMode ? null : (cdnImageSrc ?? localPreviewSrc)
	const hasCdnImage = !demoMode && !!cdnImageSrc

	const hasImage = !!imageSrc
	useEffect(() => {
		setOpenOverlayId(hasImage ? WELCOME_IMAGE_OVERLAY_ID : null)
	}, [hasImage, setOpenOverlayId])

	const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(
		undefined,
	)

	useEffect(() => {
		const isOpen = openOverlayId === WELCOME_IMAGE_OVERLAY_ID
		if (isOpen && hasCdnImage) {
			timeoutRef.current = setTimeout(() => {
				setOpenOverlayId(null)
			}, 2_000)
		}
		return () => clearTimeout(timeoutRef.current)
	}, [openOverlayId, setOpenOverlayId, hasCdnImage])

	return (
		<QrScreenOverlay
			id={WELCOME_IMAGE_OVERLAY_ID}
			previewMode={previewMode}
			bottomSlideTransition
		>
			{imageSrc ? (
				// eslint-disable-next-line @next/next/no-img-element
				<img
					src={imageSrc}
					alt="Welcome image"
					className="absolute left-1/2 top-1/2 w-full max-w-80 -translate-x-1/2 -translate-y-1/2 px-10"
				/>
			) : null}
		</QrScreenOverlay>
	)
}
